// Readers for untyped JSON: the model's args, core's display and the prepared-action content. Any field may be
// missing, blank or the wrong type.
export type Fields = Record<string, unknown>;

export function isObject(value: unknown): value is Fields {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}

export function readString(fields: Fields, key: string): string | null {
    const raw = fields[key];

    return typeof raw === "string" && raw.trim() !== "" ? raw.trim() : null;
}

// Drops a missing or blank entry.
export function readStringList(fields: Fields, key: string): string[] {
    const raw = fields[key];
    if (!Array.isArray(raw)) {
        return [];
    }

    return raw.flatMap(item => (typeof item === "string" && item.trim() !== "" ? [item.trim()] : []));
}

// A link or an image source from untyped JSON: an absolute https URL, or null, so no other scheme reaches the page.
export function toHttpsUrl(value: string | null | undefined): string | null {
    if (value === null || value === undefined) {
        return null;
    }
    try {
        return new URL(value).protocol === "https:" ? value : null;
    } catch {
        return null;
    }
}

// The model sometimes sends "true" or "false" as a string.
export function readBoolean(fields: Fields, key: string, fallback: boolean): boolean {
    const raw = fields[key];
    if (typeof raw === "boolean") {
        return raw;
    }
    if (typeof raw === "string") {
        const normalized = raw.trim().toLowerCase();
        if (normalized === "true" || normalized === "false") {
            return normalized === "true";
        }
    }

    return fallback;
}
